import React, { useState } from "react";
import { MdCheckCircle, MdSearch, MdClose } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { THEME_IMAGES } from "../themeTemplates/ThemeLayoutHelpers";

const SHOPIFY_THEMES = [
  {
    id: "dawn",
    name: "Dawn",
    tagline: "Clean lines, modern aesthetic",
    category: "General",
    price: "Free",
    rating: 4.8,
    reviews: 2341,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/999df0b9-38ca-458f-9adf-fa9b87f0af82_dawn.jpg",
    tags: ["Minimal", "Clean", "Modern"],
    colors: ["#2563eb", "#ffffff", "#1f2937"],
    industry: "General",
    themeConfig: {
      primaryColor: "#2563eb", // Blue
      secondaryColor: "#3b82f6",
      buttonColor: "#2563eb",
      backgroundColor: "#ffffff",
      textColor: "#1f2937",
      headingColor: "#111827",
      fontFamily: "Inter",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "sense",
    name: "Sense",
    tagline: "Bold visuals for modern brands",
    category: "Fashion",
    price: "Free",
    rating: 4.7,
    reviews: 1892,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/8ec17086-3ac5-428b-b94c-5455d135f13e_sense.jpg",
    tags: ["Fashion", "Bold", "Visual"],
    colors: ["#7c3aed", "#faf5ff", "#4c1d95"],
    industry: "Fashion",
    themeConfig: {
      primaryColor: "#7c3aed", // Purple
      secondaryColor: "#8b5cf6",
      buttonColor: "#7c3aed",
      backgroundColor: "#faf5ff",
      textColor: "#4c1d95",
      headingColor: "#581c87",
      fontFamily: "Poppins",
      buttonStyle: "pill",
      cardStyle: "glass",
    },
  },
  {
    id: "craft",
    name: "Craft",
    tagline: "Artisan style for handmade goods",
    category: "Artisan",
    price: "Free",
    rating: 4.6,
    reviews: 1234,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/c13f918a-3de0-4351-999e-e2959c1e8cfc_craft.webp",
    tags: ["Warm", "Handmade", "Artisan"],
    colors: ["#d97706", "#fffbeb", "#78350f"],
    industry: "Crafts & Handmade",
    themeConfig: {
      primaryColor: "#d97706", // Amber
      secondaryColor: "#fbbf24",
      buttonColor: "#d97706",
      backgroundColor: "#fffbeb",
      textColor: "#92400e",
      headingColor: "#78350f",
      fontFamily: "Roboto",
      buttonStyle: "rounded",
      cardStyle: "border",
    },
  },
  {
    id: "fresh",
    name: "Fresh",
    tagline: "Vibrant & organic for food brands",
    category: "Food & Beverage",
    price: "Free",
    rating: 4.9,
    reviews: 3102,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/826baf99-fa93-4e8d-8150-df8adb099950_fresh.jpg",
    tags: ["Food", "Organic", "Vibrant"],
    colors: ["#059669", "#f0fdf4", "#064e3b"],
    industry: "Food & Beverage",
    themeConfig: {
      primaryColor: "#059669", // Emerald
      secondaryColor: "#10b981",
      buttonColor: "#059669",
      backgroundColor: "#f0fdf4",
      textColor: "#064e3b",
      headingColor: "#065f46",
      fontFamily: "Nunito",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "empire",
    name: "Empire",
    tagline: "Luxury feel for premium brands",
    category: "Luxury",
    price: "Free",
    rating: 4.9,
    reviews: 2780,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/8a0535d2-1d6d-4f49-919d-d2da4f181bd5_empire.jpg",
    tags: ["Luxury", "Premium", "Dark"],
    colors: ["#4f46e5", "#0a0a1a", "#c7d2fe"],
    industry: "Fashion & Apparel",
    themeConfig: {
      primaryColor: "#4f46e5", // Indigo
      secondaryColor: "#818cf8",
      buttonColor: "#3730a3",
      backgroundColor: "#0a0a1a",
      textColor: "#e0e7ff",
      headingColor: "#c7d2fe",
      fontFamily: "Montserrat",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "bloom",
    name: "Bloom",
    tagline: "Soft & romantic for beauty stores",
    category: "Beauty",
    price: "Free",
    rating: 4.8,
    reviews: 1956,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/8ec5bc6a-ebf8-4e37-96f4-518e5a493184_bloom.jpg",
    tags: ["Beauty", "Feminine", "Soft"],
    colors: ["#e11d48", "#fff1f2", "#9f1239"],
    industry: "Beauty & Cosmetics",
    themeConfig: {
      primaryColor: "#e11d48", // Rose
      secondaryColor: "#fb7185",
      buttonColor: "#be123c",
      backgroundColor: "#fff1f2",
      textColor: "#881337",
      headingColor: "#9f1239",
      fontFamily: "Poppins",
      buttonStyle: "pill",
      cardStyle: "glass",
    },
  },
  {
    id: "circuit",
    name: "Circuit",
    tagline: "Sharp tech look for electronics",
    category: "Electronics",
    price: "Free",
    rating: 4.7,
    reviews: 1623,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/0c143507-5cb7-42b5-bf7a-158d87db73bc_circuit.jpg",
    tags: ["Tech", "Electronics", "Clean"],
    colors: ["#0ea5e9", "#f8fafc", "#0c4a6e"],
    industry: "Electronics",
    themeConfig: {
      primaryColor: "#0ea5e9", // Sky Blue
      secondaryColor: "#38bdf8",
      buttonColor: "#0284c7",
      backgroundColor: "#f8fafc",
      textColor: "#0c4a6e",
      headingColor: "#0369a1",
      fontFamily: "Inter",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "slate",
    name: "Slate",
    tagline: "Sleek dark mode for modern brands",
    category: "Dark",
    price: "Free",
    rating: 4.8,
    reviews: 2045,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/d96951bd-b2d1-4db2-8d6b-5e3ce0b7078e_slate.jpg",
    tags: ["Dark", "Minimal", "Sleek"],
    colors: ["#60a5fa", "#1f2937", "#f9fafb"],
    industry: "General",
    themeConfig: {
      primaryColor: "#60a5fa", // Light Blue
      secondaryColor: "#93c5fd",
      buttonColor: "#3b82f6",
      backgroundColor: "#1f2937",
      textColor: "#f3f4f6",
      headingColor: "#f9fafb",
      fontFamily: "Montserrat",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "grove",
    name: "Grove",
    tagline: "Natural & eco-friendly aesthetics",
    category: "Health",
    price: "Free",
    rating: 4.6,
    reviews: 987,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/0004707d-8eac-4605-8879-0b5f4d1dcadd_grove.jpg",
    tags: ["Eco", "Health", "Natural"],
    colors: ["#65a30d", "#f7fee7", "#365314"],
    industry: "Health & Wellness",
    themeConfig: {
      primaryColor: "#65a30d", // Lime
      secondaryColor: "#84cc16",
      buttonColor: "#4d7c0f",
      backgroundColor: "#f7fee7",
      textColor: "#365314",
      headingColor: "#1a2e05",
      fontFamily: "Nunito",
      buttonStyle: "pill",
      cardStyle: "border",
    },
  },
  {
    id: "tide",
    name: "Tide",
    tagline: "Oceanic vibes for lifestyle stores",
    category: "Lifestyle",
    price: "Free",
    rating: 4.7,
    reviews: 1412,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/dd49892d-03d3-478f-adb0-c3ac58fa2276_tide.jpg",
    tags: ["Lifestyle", "Fresh", "Ocean"],
    colors: ["#0284c7", "#f0f9ff", "#0c4a6e"],
    industry: "Lifestyle",
    themeConfig: {
      primaryColor: "#0284c7", // Azure
      secondaryColor: "#38bdf8",
      buttonColor: "#0284c7",
      backgroundColor: "#f0f9ff",
      textColor: "#0c4a6e",
      headingColor: "#0369a1",
      fontFamily: "Inter",
      buttonStyle: "rounded",
      cardStyle: "glass",
    },
  },
  {
    id: "aurora",
    name: "Aurora",
    tagline: "Dreamy gradients for creative brands",
    category: "Creative",
    price: "Free",
    rating: 4.9,
    reviews: 3456,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/03e42da8-fe60-49f7-ab25-841287963af7_aurora.jpg",
    tags: ["Creative", "Gradient", "Dreamy"],
    colors: ["#6366f1", "#f8f8ff", "#3730a3"],
    industry: "Creative & Art",
    themeConfig: {
      primaryColor: "#6366f1", // Royal Purple
      secondaryColor: "#a5b4fc",
      buttonColor: "#4f46e5",
      backgroundColor: "#f8f8ff",
      textColor: "#3730a3",
      headingColor: "#312e81",
      fontFamily: "Poppins",
      buttonStyle: "pill",
      cardStyle: "shadow",
    },
  },
  {
    id: "spice",
    name: "Spice",
    tagline: "Bold & fiery for restaurant brands",
    category: "Food & Beverage",
    price: "Free",
    rating: 4.5,
    reviews: 876,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/cd2073c4-a489-4dc4-b4aa-212e3f8ffd8f_spice.jpg",
    tags: ["Food", "Bold", "Restaurant"],
    colors: ["#dc2626", "#fff5f5", "#991b1b"],
    industry: "Food & Beverage",
    themeConfig: {
      primaryColor: "#dc2626", // Red
      secondaryColor: "#ef4444",
      buttonColor: "#b91c1c",
      backgroundColor: "#fff5f5",
      textColor: "#7f1d1d",
      headingColor: "#991b1b",
      fontFamily: "Roboto",
      buttonStyle: "rounded",
      cardStyle: "border",
    },
  },
  {
    id: "regal",
    name: "Regal",
    tagline: "Premium elegance for luxury catalogs",
    category: "Luxury",
    price: "Free",
    rating: 4.8,
    reviews: 1544,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/f2f340f1-689d-4244-b6be-cca19827a69f_regal.jpg",
    tags: ["Luxury", "Jewelry", "Premium"],
    colors: ["#7c2d12", "#fffaf0", "#4a1d10"],
    industry: "Jewelry & Premium",
    themeConfig: {
      primaryColor: "#7c2d12", // Dark Brown
      secondaryColor: "#b45309",
      buttonColor: "#7c2d12",
      backgroundColor: "#fffaf0",
      textColor: "#4a1d10",
      headingColor: "#7c2d12",
      fontFamily: "Playfair Display",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "meadow",
    name: "Meadow",
    tagline: "Calm botanical style for garden stores",
    category: "Health",
    price: "Free",
    rating: 4.7,
    reviews: 1127,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/bae0c62f-7d8c-49d2-9ab2-06b260382b3b_meadow.jpg",
    tags: ["Nature", "Garden", "Calm"],
    colors: ["#166534", "#f0fdf4", "#14532d"],
    industry: "Nursery & Garden",
    themeConfig: {
      primaryColor: "#166534", // Forest Green
      secondaryColor: "#16a34a",
      buttonColor: "#15803d",
      backgroundColor: "#f0fdf4",
      textColor: "#14532d",
      headingColor: "#14532d",
      fontFamily: "DM Sans",
      buttonStyle: "pill",
      cardStyle: "glass",
    },
  },
  {
    id: "pantry",
    name: "Pantry",
    tagline: "Fast-moving grocery layout with bright aisle energy",
    category: "Grocery",
    price: "Free",
    rating: 4.9,
    reviews: 2164,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/4ed43227-dab6-4991-9523-54fc332a7173_pantry.jpg",
    tags: ["Grocery", "Retail", "Fresh"],
    colors: ["#16a34a", "#fffbeb", "#14532d"],
    industry: "Grocery & Supermarket",
    themeConfig: {
      primaryColor: "#16a34a", // Green
      secondaryColor: "#f59e0b",
      buttonColor: "#15803d",
      backgroundColor: "#fffbeb",
      textColor: "#14532d",
      headingColor: "#166534",
      fontFamily: "Nunito",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "atelier",
    name: "Atelier",
    tagline: "Editorial storefront tailored for apparel catalogs",
    category: "Apparel",
    price: "Free",
    rating: 4.8,
    reviews: 1742,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/00e4dd27-05d8-4418-8d0b-f9872c5f706a_atelier.jpg",
    tags: ["Apparel", "Editorial", "Fashion"],
    colors: ["#be185d", "#fff7fb", "#500724"],
    industry: "Clothing & Textile",
    themeConfig: {
      primaryColor: "#be185d", // Pink
      secondaryColor: "#ec4899",
      buttonColor: "#831843",
      backgroundColor: "#fff7fb",
      textColor: "#500724",
      headingColor: "#831843",
      fontFamily: "Montserrat",
      buttonStyle: "pill",
      cardStyle: "glass",
    },
  },
  {
    id: "remedy",
    name: "Remedy",
    tagline: "Trust-first layout for pharmacies and medical stores",
    category: "Pharmacy",
    price: "Free",
    rating: 4.8,
    reviews: 1588,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/856511e4-f686-4358-bb0b-2151f159d7b4_remedy.jpg",
    tags: ["Medical", "Clean", "Trusted"],
    colors: ["#0f766e", "#f0fdfa", "#134e4a"],
    industry: "Pharmacy & Medical",
    themeConfig: {
      primaryColor: "#0f766e", // Teal
      secondaryColor: "#14b8a6",
      buttonColor: "#0f766e",
      backgroundColor: "#f0fdfa",
      textColor: "#134e4a",
      headingColor: "#115e59",
      fontFamily: "Inter",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "forge",
    name: "Forge",
    tagline: "Industrial polish for manufacturing and B2B catalogs",
    category: "Manufacturing",
    price: "Free",
    rating: 4.7,
    reviews: 1204,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/8681900b-4309-4060-9beb-9a1d293b9bb0_forge.jpg",
    tags: ["Industrial", "B2B", "Tools"],
    colors: ["#334155", "#f8fafc", "#0f172a"],
    industry: "Manufacturing",
    themeConfig: {
      primaryColor: "#334155", // Slate
      secondaryColor: "#f59e0b",
      buttonColor: "#1e293b",
      backgroundColor: "#f8fafc",
      textColor: "#1e293b",
      headingColor: "#0f172a",
      fontFamily: "Montserrat",
      buttonStyle: "rounded",
      cardStyle: "border",
    },
  },
  {
    id: "ovenly",
    name: "Ovenly",
    tagline: "Warm bakery showcase built around fresh batches",
    category: "Bakery",
    price: "Free",
    rating: 4.9,
    reviews: 2027,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/4a66e016-e046-4286-9b20-7d3f075218fe_ovenly.jpg",
    tags: ["Bakery", "Warm", "Pastry"],
    colors: ["#c2410c", "#fff7ed", "#7c2d12"],
    industry: "Bakery",
    themeConfig: {
      primaryColor: "#c2410c", // Orange
      secondaryColor: "#f59e0b",
      buttonColor: "#9a3412",
      backgroundColor: "#fff7ed",
      textColor: "#7c2d12",
      headingColor: "#9a3412",
      fontFamily: "DM Sans",
      buttonStyle: "pill",
      cardStyle: "shadow",
    },
  },
  {
    id: "harvest",
    name: "Harvest",
    tagline: "Field-to-shelf storytelling for farm businesses",
    category: "Agriculture",
    price: "Free",
    rating: 4.8,
    reviews: 1336,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/b0096b7c-2512-4ae2-857c-006ee37e2789_harvest.jpg",
    tags: ["Farm", "Organic", "Earthy"],
    colors: ["#3f6212", "#fefce8", "#365314"],
    industry: "Farms & Agriculture",
    themeConfig: {
      primaryColor: "#3f6212", // Olive
      secondaryColor: "#ca8a04",
      buttonColor: "#4d7c0f",
      backgroundColor: "#fefce8",
      textColor: "#365314",
      headingColor: "#365314",
      fontFamily: "Nunito",
      buttonStyle: "rounded",
      cardStyle: "border",
    },
  },
  {
    id: "midnight",
    name: "Midnight",
    tagline: "Luxury dark mode with premium feel",
    category: "Luxury",
    price: "Free",
    rating: 4.9,
    reviews: 1876,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/19f7e6d5-6c94-43a3-be87-3ba1cb58267b_midnightx.jpg",
    tags: ["Luxury", "Dark", "Premium", "Elegant"],
    colors: ["#8b5cf6", "#0f0f1a", "#c084fc"],
    industry: "Luxury & Premium",
    themeConfig: {
      primaryColor: "#8b5cf6", // Violet
      secondaryColor: "#c084fc",
      buttonColor: "#7c3aed",
      backgroundColor: "#0f0f1a",
      textColor: "#d1d5db",
      headingColor: "#ffffff",
      fontFamily: "Inter",
      buttonStyle: "pill",
      cardStyle: "glass",
    },
  },
  {
    id: "mint",
    name: "Mint",
    tagline: "Fresh eco-friendly aesthetic for conscious brands",
    category: "Health",
    price: "Free",
    rating: 4.8,
    reviews: 2341,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/f08becab-d0a2-454e-9afe-d7ad654b5c1c_minty.jpg",
    tags: ["Eco", "Fresh", "Natural", "Sustainable"],
    colors: ["#059669", "#f0fdf4", "#10b981"],
    industry: "Health & Wellness",
    themeConfig: {
      primaryColor: "#0d9488", // Teal Green
      secondaryColor: "#14b8a6",
      buttonColor: "#0f766e",
      backgroundColor: "#f0fdf4",
      textColor: "#065f46",
      headingColor: "#022c22",
      fontFamily: "Poppins",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "lunar",
    name: "Lunar",
    tagline: "Ultra-minimalist dark theme for modern brands",
    category: "Dark",
    price: "Free",
    rating: 4.7,
    reviews: 1543,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/0f54be5d-008b-4d32-9a8c-ceb3f5833bb1_lunar.jpg",
    tags: ["Minimal", "Dark", "Sleek", "Modern"],
    colors: ["#94a3b8", "#0a0a0a", "#64748b"],
    industry: "General",
    themeConfig: {
      primaryColor: "#f472b6", // Pink Rose
      secondaryColor: "#64748b",
      buttonColor: "#ffffff",
      backgroundColor: "#0a0a0a",
      textColor: "#cbd5e1",
      headingColor: "#ffffff",
      fontFamily: "Inter",
      buttonStyle: "rounded",
      cardStyle: "border",
    },
  },
  {
    id: "solar",
    name: "Solar",
    tagline: "Warm energetic theme for vibrant brands",
    category: "Lifestyle",
    price: "Free",
    rating: 4.8,
    reviews: 2098,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/71b83dfe-30ee-495b-8477-019e91c410c7_solar.jpg",
    tags: ["Warm", "Energetic", "Vibrant", "Sunny"],
    colors: ["#ea580c", "#fff7ed", "#fbbf24"],
    industry: "Lifestyle & Travel",
    themeConfig: {
      primaryColor: "#ea580c", // Orange Bright
      secondaryColor: "#fbbf24",
      buttonColor: "#ea580c",
      backgroundColor: "#fff7ed",
      textColor: "#431407",
      headingColor: "#7c2d12",
      fontFamily: "Poppins",
      buttonStyle: "pill",
      cardStyle: "shadow",
    },
  },
  {
    id: "coral",
    name: "Coral",
    tagline: "Bold playful theme for fashion & lifestyle",
    category: "Fashion",
    price: "Free",
    rating: 4.9,
    reviews: 3124,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/ccd53aa8-e10a-470b-9883-094384b18853_coral.jpg",
    tags: ["Bold", "Playful", "Vibrant", "Trendy"],
    colors: ["#f43f5e", "#fff1f2", "#fb923c"],
    industry: "Fashion & Apparel",
    themeConfig: {
      primaryColor: "#f43f5e", // Crimson
      secondaryColor: "#fb923c",
      buttonColor: "#e11d48",
      backgroundColor: "#fff1f2",
      textColor: "#881337",
      headingColor: "#9f1239",
      fontFamily: "DM Sans",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "arctic",
    name: "Arctic",
    tagline: "Cool clean theme for modern stores",
    category: "General",
    price: "Free",
    rating: 4.7,
    reviews: 1876,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/022fdebc-68f2-42a6-b3a9-e3e8407e2f75_arctic.jpg",
    tags: ["Cool", "Clean", "Fresh", "Modern"],
    colors: ["#0891b2", "#f0f9ff", "#22d3ee"],
    industry: "General",
    themeConfig: {
      primaryColor: "#0891b2", // Cyan
      secondaryColor: "#22d3ee",
      buttonColor: "#0891b2",
      backgroundColor: "#f0f9ff",
      textColor: "#0c4a6e",
      headingColor: "#082f49",
      fontFamily: "Inter",
      buttonStyle: "rounded",
      cardStyle: "glass",
    },
  },
  {
    id: "elysian",
    name: "Elysian",
    tagline: "Animated elegance with model-led storytelling",
    category: "Fashion",
    price: "Free",
    rating: 5.0,
    reviews: 3421,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/d22c53b9-f618-44f6-b7b8-3c2b7369bbcb_ensle.jpg",
    tags: ["Animated", "Model", "Elegant", "Aesthetic", "Luxury"],
    colors: ["#2d1b4e", "#f5e6d3", "#c9a96e", "#1a1a2e", "#e8d5c4"],
    industry: "Fashion & Luxury",
    themeConfig: {
      primaryColor: "#2d1b4e", // Dark Purple
      secondaryColor: "#c9a96e",
      buttonColor: "#c9a96e",
      backgroundColor: "#faf6f0",
      textColor: "#2d1b4e",
      headingColor: "#1a1a2e",
      fontFamily: "Playfair Display, Georgia, serif",
      buttonStyle: "pill",
      cardStyle: "glass",
    },
  },
  {
    id: "aura",
    name: "Aura",
    tagline: "Luxury jewelry showcase with radiant elegance",
    category: "Luxury",
    price: "Free",
    rating: 5.0,
    reviews: 2894,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/724b3e70-33c5-4d68-9bc5-38631edd2f2f_aura.jpg",
    tags: ["Jewelry", "Luxury", "Elegant", "Sparkle", "Premium"],
    colors: ["#1a1a2e", "#d4af37", "#f5e6d3", "#2d1b4e", "#c9a96e"],
    industry: "Jewelry & Accessories",
    themeConfig: {
      primaryColor: "#c9a96e", // Gold
      secondaryColor: "#1a1a2e",
      buttonColor: "#c9a96e",
      backgroundColor: "#0a0a12",
      textColor: "#e8e8e8",
      headingColor: "#d4af37",
      fontFamily: "Cormorant Garamond, Georgia, serif",
      buttonStyle: "pill",
      cardStyle: "glass",
    },
  },
  {
    id: "velora",
    name: "Velora",
    tagline: "Avant-garde fashion with dynamic animations",
    category: "Fashion",
    price: "Free",
    rating: 5.0,
    reviews: 4123,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/4598d58d-4f56-4916-b93a-d1c1401bee4b_velora.jpg",
    tags: ["Fashion", "Animated", "Dynamic", "Modern", "Avant-garde"],
    colors: ["#ff6b6b", "#4ecdc4", "#1a1a2e", "#ffe66d", "#f7fff7"],
    industry: "Fashion & Apparel",
    themeConfig: {
      primaryColor: "#ff6b6b", // Coral Red
      secondaryColor: "#4ecdc4",
      buttonColor: "#ff6b6b",
      backgroundColor: "#f7fff7",
      textColor: "#1a1a2e",
      headingColor: "#1a1a2e",
      fontFamily: "Montserrat, sans-serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "orbit",
    name: "Orbit",
    tagline: "Products orbit around a central runway",
    category: "Fashion",
    price: "Free",
    rating: 4.9,
    reviews: 2876,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/76d80a10-f428-498e-a615-dd7b06cba415_3.jpg",
    tags: ["Orbit", "Runway", "Circular", "Dynamic"],
    colors: ["#ff3366", "#2b2d42", "#8d99ae", "#edf2f4"],
    industry: "Fashion",
    themeConfig: {
      primaryColor: "#ff3366", // Hot Pink
      secondaryColor: "#2b2d42",
      buttonColor: "#ff3366",
      backgroundColor: "#ffffff",
      textColor: "#2b2d42",
      headingColor: "#2b2d42",
      fontFamily: "Inter, sans-serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "vogue",
    name: "Vogue",
    tagline: "Full screen designer dress model animates into place",
    category: "Fashion",
    price: "Free",
    rating: 5.0,
    reviews: 7890,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/1ffad972-856d-423f-972f-4259bea1141b_vouge.avif",
    tags: ["Vogue", "Model", "Hero", "Elegant", "Couture", "Designer"],
    colors: ["#000000", "#d4af37", "#ffffff", "#333333"],
    industry: "Fashion",
    themeConfig: {
      primaryColor: "#d4af37", // Metallic Gold
      secondaryColor: "#000000",
      buttonColor: "#d4af37",
      backgroundColor: "#ffffff",
      textColor: "#333333",
      headingColor: "#000000",
      fontFamily: "Playfair Display, serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "royalcouture",
    name: "Royal Couture",
    tagline: "Luxury gowns with cinematic floating animation",
    category: "Fashion",
    price: "Free",
    rating: 5.0,
    reviews: 9234,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/18ab0121-1b8b-4c43-9045-563881abc22a_couture.avif",
    tags: ["Gowns", "Luxury", "Cinematic", "Royal", "Elegant"],
    colors: ["#0a0a2a", "#8B008B", "#ffffff", "#2d1b4e"],
    industry: "Fashion - Gowns",
    themeConfig: {
      primaryColor: "#8B008B", // Dark Magenta
      secondaryColor: "#0a0a2a",
      buttonColor: "#8B008B",
      backgroundColor: "#0a0a2a",
      textColor: "#ffffff",
      headingColor: "#8B008B",
      fontFamily: "Cormorant Garamond, serif",
      buttonStyle: "pill",
      cardStyle: "glass",
    },
  },
  {
    id: "brewblend",
    name: "Brew & Blend",
    tagline: "Artisanal beverages, ethically sourced and expertly prepared",
    category: "Food & Beverage",
    price: "Free",
    rating: 4.9,
    reviews: 2156,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/cc9b49b9-08ab-448a-9263-a02e1963212d_a.jpg",
    tags: ["Coffee", "Tea", "Beverage", "Artisan"],
    colors: ["#78350f", "#fef3c7", "#92400e"],
    industry: "Beverage",
    themeConfig: {
      primaryColor: "#78350f", // Dark Amber
      secondaryColor: "#d97706",
      buttonColor: "#92400e",
      backgroundColor: "#fffbeb",
      textColor: "#78350f",
      headingColor: "#451a03",
      fontFamily: "Nunito, sans-serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "goldenharvest",
    name: "Golden Harvest",
    tagline: "Artisan breads and pastries, made fresh daily",
    category: "Bakery",
    price: "Free",
    rating: 4.8,
    reviews: 1876,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/1dfc2629-f789-4ef0-bb07-dc4851ac683b_b1.jpg",
    tags: ["Bakery", "Bread", "Pastry", "Artisan"],
    colors: ["#78350f", "#fef3c7", "#92400e"],
    industry: "Bakery",
    themeConfig: {
      primaryColor: "#b45309", // Golden Brown
      secondaryColor: "#d97706",
      buttonColor: "#92400e",
      backgroundColor: "#fffbeb",
      textColor: "#78350f",
      headingColor: "#451a03",
      fontFamily: "DM Sans, sans-serif",
      buttonStyle: "pill",
      cardStyle: "shadow",
    },
  },
  {
    id: "freshpantry",
    name: "Fresh Pantry",
    tagline: "Fresh groceries delivered daily from local farms",
    category: "Grocery",
    price: "Free",
    rating: 4.7,
    reviews: 3421,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/c65d44b1-6c1c-4c6e-ad9d-acb38b761e0b_l-intro-1730486316.jpg",
    tags: ["Grocery", "Fresh", "Farm", "Organic"],
    colors: ["#065f46", "#ecfdf5", "#047857"],
    industry: "Grocery",
    themeConfig: {
      primaryColor: "#065f46", // Deep Green
      secondaryColor: "#047857",
      buttonColor: "#065f46",
      backgroundColor: "#ecfdf5",
      textColor: "#064e3b",
      headingColor: "#022c22",
      fontFamily: "Inter, sans-serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "bloomflora",
    name: "Bloom Flora",
    tagline: "Where flowers tell your story",
    category: "Flowers",
    price: "Free",
    rating: 4.9,
    reviews: 2894,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/b4120590-e5e1-435a-99f5-a2f0ddc66f65_flower.webp",
    tags: ["Flowers", "Romantic", "Bouquets", "Wedding"],
    colors: ["#db2777", "#fce7f3", "#f472b6"],
    industry: "Florist",
    themeConfig: {
      primaryColor: "#db2777", // Fuchsia (UNIQUE)
      secondaryColor: "#f472b6",
      buttonColor: "#db2777",
      backgroundColor: "#fdf2f8",
      textColor: "#9f1239",
      headingColor: "#881337",
      fontFamily: "Playfair Display, serif",
      buttonStyle: "pill",
      cardStyle: "shadow",
    },
  },
  {
    id: "luxesalon",
    name: "Luxe Salon",
    tagline: "Where beauty meets luxury",
    category: "Salon & Beauty",
    price: "Free",
    rating: 5.0,
    reviews: 3124,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/cb0407bd-baed-47fb-9e74-3504897464db_27.jpg",
    tags: ["Salon", "Beauty", "Luxury", "Hair", "Skin", "Makeup"],
    colors: ["#8B4513", "#d4af37", "#2d1b0e", "#f5f0eb"],
    industry: "Salon & Beauty",
    themeConfig: {
      primaryColor: "#8B4513", // Saddle Brown (UNIQUE)
      secondaryColor: "#d4af37",
      buttonColor: "#8B4513",
      backgroundColor: "#f5f0eb",
      textColor: "#2d1b0e",
      headingColor: "#2d1b0e",
      fontFamily: "Playfair Display, serif",
      buttonStyle: "pill",
      cardStyle: "shadow",
    },
  },
  {
    id: "ironforge",
    name: "Iron Forge",
    tagline: "Forge your best self",
    category: "Gym & Fitness",
    price: "Free",
    rating: 4.9,
    reviews: 2876,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/df1f4d0c-9a7c-40da-9c86-01d65aba6d6f_a1.jpg",
    tags: ["Gym", "Fitness", "Strength", "Training"],
    colors: ["#b91c1c", "#000000", "#f97316"],
    industry: "Gym & Fitness",
    themeConfig: {
      primaryColor: "#b91c1c", // Dark Red (UNIQUE - different from Spice's #dc2626)
      secondaryColor: "#f97316",
      buttonColor: "#b91c1c",
      backgroundColor: "#000000",
      textColor: "#ffffff",
      headingColor: "#ffffff",
      fontFamily: "Inter, sans-serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "agriharvest",
    name: "Agri Harvest",
    tagline: "Nourishing the future of farming",
    category: "Agriculture",
    price: "Free",
    rating: 4.8,
    reviews: 2341,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/1a2a66be-1ba0-41af-8d3a-b55f1d9fd264_agri2.jpg",
    tags: ["Agriculture", "Farming", "Seeds", "Fertilizers", "Pesticides"],
    colors: ["#15803d", "#fefce8", "#22c55e"],
    industry: "Agriculture & Farming",
    themeConfig: {
      primaryColor: "#15803d", // Dark Green (UNIQUE - different from Meadow's #166534)
      secondaryColor: "#22c55e",
      buttonColor: "#15803d",
      backgroundColor: "#fefce8",
      textColor: "#14532d",
      headingColor: "#064e3b",
      fontFamily: "DM Sans, sans-serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "hardwarepro",
    name: "Hardware Pro",
    tagline: "Build with confidence",
    category: "Hardware",
    price: "Free",
    rating: 4.8,
    reviews: 2567,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/a8415eec-007c-42cb-a0e0-1084d885b373_h1.jpg",
    tags: ["Hardware", "Tools", "Construction", "Building Materials"],
    colors: ["#f97316", "#2d1b0e", "#fb923c"],
    industry: "Hardware & Construction",
    themeConfig: {
      primaryColor: "#f97316", // Orange (UNIQUE - different from Solar's #ea580c)
      secondaryColor: "#fb923c",
      buttonColor: "#f97316",
      backgroundColor: "#fef3c7",
      textColor: "#2d1b0e",
      headingColor: "#2d1b0e",
      fontFamily: "Inter, sans-serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
  {
    id: "stationerypro",
    name: "Stationery Pro",
    tagline: "Write your story",
    category: "Stationery",
    price: "Free",
    rating: 4.7,
    reviews: 1892,
    image:
      "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/624be9de-8796-47d6-bf3e-d5cbb813dc92_Premium_Notebook_(Set_of_5).jpg",
    tags: ["Stationery", "School Supplies", "Office", "Art", "Craft"],
    colors: ["#4f46e5", "#1a365d", "#818cf8"],
    industry: "Stationery & Supplies",
    themeConfig: {
      primaryColor: "#4f46e5", // Indigo (UNIQUE - different from Dawn's #2563eb)
      secondaryColor: "#818cf8",
      buttonColor: "#4f46e5",
      backgroundColor: "#eff6ff",
      textColor: "#1a365d",
      headingColor: "#1a365d",
      fontFamily: "Poppins, sans-serif",
      buttonStyle: "rounded",
      cardStyle: "shadow",
    },
  },
];

const CATEGORIES = [
  "All",
  "Fashion",
  "Electronics",
  "Beauty",
  "Health",
  "Lifestyle",
  "Dark",
  "Artisan",
  "Luxury",
  "Creative",
  "General",
  "Grocery",
  "Apparel",
  "Pharmacy",
  "Manufacturing",
  "Bakery",
  "Agriculture",
  "Beverage",
];

const getThemeTagline = (t, theme) => theme.tagline;

const getThemeCategory = (t, category) => category;

const getThemeTags = (t, tags = []) => tags;

const THEME_LAYOUT_PRESETS = {
  dawn: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  sense: {
    heroVariant: "split",
    productVariant: "editorial",
    sectionDensity: "airy",
  },
  craft: {
    heroVariant: "split",
    productVariant: "grid",
    sectionDensity: "airy",
  },
  fresh: {
    heroVariant: "overlay",
    productVariant: "carousel",
    sectionDensity: "compact",
  },
  empire: {
    heroVariant: "overlay",
    productVariant: "editorial",
    sectionDensity: "spacious",
  },
  bloom: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "airy",
  },
  circuit: {
    heroVariant: "split",
    productVariant: "carousel",
    sectionDensity: "compact",
  },
  slate: {
    heroVariant: "overlay",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  grove: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  tide: {
    heroVariant: "split",
    productVariant: "carousel",
    sectionDensity: "airy",
  },
  aurora: {
    heroVariant: "overlay",
    productVariant: "editorial",
    sectionDensity: "spacious",
  },
  spice: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "compact",
  },
  regal: {
    heroVariant: "overlay",
    productVariant: "editorial",
    sectionDensity: "spacious",
  },
  meadow: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  pantry: {
    heroVariant: "split",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  atelier: {
    heroVariant: "split",
    productVariant: "editorial",
    sectionDensity: "airy",
  },
  remedy: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  forge: {
    heroVariant: "overlay",
    productVariant: "grid",
    sectionDensity: "compact",
  },
  ovenly: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  harvest: {
    heroVariant: "split",
    productVariant: "grid",
    sectionDensity: "airy",
  },
  midnight: {
    heroVariant: "overlay",
    productVariant: "grid",
    sectionDensity: "spacious",
  },
  mint: {
    heroVariant: "split",
    productVariant: "grid",
    sectionDensity: "airy",
  },
  lunar: {
    heroVariant: "overlay",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  solar: {
    heroVariant: "classic",
    productVariant: "carousel",
    sectionDensity: "compact",
  },
  coral: {
    heroVariant: "split",
    productVariant: "grid",
    sectionDensity: "airy",
  },
  arctic: {
    heroVariant: "split",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  elysian: {
    heroVariant: "animated",
    productVariant: "masonry",
    sectionDensity: "airy",
  },
  aura: {
    heroVariant: "jewelry",
    productVariant: "grid",
    sectionDensity: "spacious",
  },
  velora: {
    heroVariant: "animated",
    productVariant: "flyin",
    sectionDensity: "dynamic",
  },
  orbit: {
    heroVariant: "runway",
    productVariant: "orbital",
    sectionDensity: "circular",
  },
  vogue: {
    heroVariant: "single-model",
    productVariant: "flyin",
    sectionDensity: "elegant",
  },
  royalcouture: {
    heroVariant: "cinematic",
    productVariant: "floating",
    sectionDensity: "royal",
  },
  brewblend: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  goldenharvest: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  freshpantry: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  bloomflora: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  luxesalon: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "airy",
  },
  ironforge: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  agriharvest: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  hardwarepro: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
  stationerypro: {
    heroVariant: "classic",
    productVariant: "grid",
    sectionDensity: "balanced",
  },
};

// ─── Single theme card ───────────────────────────────────────────────────────
const ThemeCard = ({ theme, isActive, onApply, onPreview }) => {
  const [hovered, setHovered] = useState(false);
  const { t } = useTranslation();
  const localizedTagline = getThemeTagline(t, theme);
  const localizedCategory = getThemeCategory(t, theme.category);
  const localizedTags = getThemeTags(t, theme.tags);

  return (
    <div
      className={`group relative rounded-2xl overflow-hidden transition-all duration-300 bg-white dark:bg-gray-800 ${
        isActive
          ? "ring-4 ring-green-500 shadow-2xl shadow-green-100 dark:shadow-green-900/30"
          : "shadow-md hover:shadow-2xl hover:-translate-y-1"
      }`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Active badge */}
      {isActive && (
        <div className='absolute top-3 left-3 z-20 flex items-center gap-1.5 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg'>
          <MdCheckCircle size={13} />
          {t("SETTINGS.THEME_STORE.ACTIVE_THEME")}
        </div>
      )}

      {/* Free badge */}
      <div className='absolute top-3 right-3 z-20 bg-emerald-500 text-white text-[10px] font-bold px-2.5 py-1 rounded-full shadow'>
        {t("SETTINGS.THEME_STORE.FREE")}
      </div>

      {/* Image area */}
      <div className='relative h-52 overflow-hidden'>
        <img
          src={theme.image}
          alt={theme.name}
          className='w-full h-full object-cover transition-transform duration-500 group-hover:scale-105'
          loading='lazy'
        />
        {/* Color overlay tint */}
        <div
          className='absolute inset-0 opacity-30'
          style={{ backgroundColor: theme.themeConfig.primaryColor }}
        />
        {/* Simulated nav bar on top of image */}
        <div
          className='absolute top-0 left-0 right-0 flex items-center justify-between px-3 py-2'
          style={{ backgroundColor: theme.themeConfig.primaryColor + "ee" }}
        >
          <div className='text-white text-[9px] font-bold'>
            ● {t("SETTINGS.THEME_STORE.YOUR_STORE")}
          </div>
          <div className='flex gap-2'>
            {[
              t("SETTINGS.THEME_STORE.HOME"),
              t("SETTINGS.THEME_STORE.SHOP"),
            ].map((n) => (
              <span key={n} className='text-white/80 text-[7px]'>
                {n}
              </span>
            ))}
          </div>
          <div
            className='text-white text-[7px] px-1.5 py-0.5 border border-white/50'
            style={{
              borderRadius:
                theme.themeConfig.buttonStyle === "pill" ? "999px" : "3px",
            }}
          >
            {t("SETTINGS.THEME_STORE.CART")}
          </div>
        </div>

        {/* Hover overlay with CTA buttons */}
        <div
          className={`absolute inset-0 flex flex-col items-center justify-center gap-3 transition-all duration-300 ${
            hovered ? "opacity-100" : "opacity-0"
          }`}
          style={{
            backgroundColor: "rgba(0,0,0,0.6)",
            backdropFilter: "blur(3px)",
          }}
        >
          {isActive ? (
            <div className='flex items-center gap-2 bg-green-500 text-white px-5 py-2.5 rounded-xl font-bold text-sm shadow-lg'>
              <MdCheckCircle size={16} /> {t("SETTINGS.THEME_STORE.APPLIED")}
            </div>
          ) : (
            <button
              onClick={() => onApply(theme)}
              className='px-6 py-2.5 bg-white text-gray-900 rounded-xl font-bold text-sm hover:bg-gray-50 transition-colors shadow-lg'
            >
              {t("SETTINGS.THEME_STORE.APPLY_THEME")}
            </button>
          )}
          <button
            onClick={() => onPreview(theme)}
            className='px-5 py-2 border-2 border-white text-white rounded-xl text-sm font-semibold hover:bg-white hover:text-gray-900 transition-colors'
          >
            {t("SETTINGS.THEME_STORE.PREVIEW")}
          </button>
        </div>
      </div>

      {/* Card body */}
      <div className='p-4'>
        <div className='flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between mb-2'>
          <div className='min-w-0'>
            <h3 className='font-bold text-gray-900 dark:text-white text-base leading-tight'>
              {theme.name}
            </h3>
            <p className='text-xs text-gray-500 dark:text-gray-400 mt-0.5 line-clamp-2'>
              {localizedTagline}
            </p>
          </div>
          <span className='text-xs bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 px-2 py-1 rounded-lg font-medium shrink-0 self-start sm:ml-2'>
            {localizedCategory}
          </span>
        </div>

        {/* Color swatches */}
        <div className='flex flex-wrap gap-1.5 mb-3'>
          {theme.colors.map((c, i) => (
            <div
              key={i}
              className='w-5 h-5 rounded-full border-2 border-white shadow-sm'
              style={{ backgroundColor: c }}
              title={c}
            />
          ))}
          <div className='flex flex-wrap gap-1 ml-1'>
            {localizedTags.map((tag) => (
              <span
                key={tag}
                className='text-[10px] bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1.5 py-0.5 rounded-full'
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        {/* Action button */}
        {isActive ? (
          <div className='w-full py-2 text-center text-sm font-semibold text-green-700 dark:text-green-400 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-800 flex items-center justify-center gap-1.5'>
            <MdCheckCircle size={15} />{" "}
            {t("SETTINGS.THEME_STORE.CURRENTLY_ACTIVE")}
          </div>
        ) : (
          <div className='flex flex-col sm:flex-row gap-2'>
            <button
              onClick={() => onApply(theme)}
              className='flex-1 py-2 text-sm font-semibold text-white rounded-xl transition-all hover:opacity-90'
              style={{ backgroundColor: theme.themeConfig.primaryColor }}
            >
              {t("SETTINGS.THEME_STORE.APPLY_THEME")}
            </button>
            <button
              onClick={() => onPreview(theme)}
              className='px-3 py-2 text-sm font-semibold text-gray-600 dark:text-gray-300 border-2 border-gray-200 dark:border-gray-600 rounded-xl hover:border-gray-400 dark:hover:border-gray-400 transition-colors sm:w-auto'
            >
              {t("SETTINGS.THEME_STORE.PREVIEW")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// ─── Main ThemeGallery component ─────────────────────────────────────────────
const ThemeGallery = ({
  storeTheme,
  onApplyTheme,
  onPreview,
  allThemesById = {},
}) => {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const activeThemeName = storeTheme?.themeName;

  const filtered = SHOPIFY_THEMES.filter((theme) => {
    const matchCat =
      activeCategory === "All" || theme.category === activeCategory;
    const q = searchQuery.toLowerCase().trim();
    const localizedTagline = getThemeTagline(t, theme).toLowerCase();
    const localizedCategory = getThemeCategory(t, theme.category).toLowerCase();
    const localizedTags = getThemeTags(t, theme.tags).join(" ").toLowerCase();
    const matchSearch =
      !q ||
      theme.name.toLowerCase().includes(q) ||
      localizedTagline.includes(q) ||
      localizedCategory.includes(q) ||
      localizedTags.includes(q) ||
      theme.industry.toLowerCase().includes(q);
    return matchCat && matchSearch;
  });

  // ─── NEW: Define which themes are "Rich Themes" ──────────────────────────
  // These premium themes will be displayed in the "Rich themes" section
  const PREMIUM_THEME_IDS = [
    "elysian", // Rating 5.0
    "aura", // Rating 5.0
    "velora", // Rating 5.0
    "vogue", // Rating 5.0
    "royalcouture", // Rating 5.0
    "orbit", // Rating 4.9
    "brewblend", // Rating 4.9
    "bloomflora", // Rating 4.9
    "goldenharvest", // Rating 4.8
    "freshpantry", // Rating 4.7
    "luxesalon",
    "ironforge", // Rating 4.9
    "agriharvest",
    "hardwarepro",
    "stationerypro",
  ];

  // Split filtered themes into Premium and Regular
  const premiumThemes = filtered.filter((theme) =>
    PREMIUM_THEME_IDS.includes(theme.id),
  );
  const regularThemes = filtered.filter(
    (theme) => !PREMIUM_THEME_IDS.includes(theme.id),
  );

  // Sort premium themes: Elysian first (id: 'elysian'), then by rating
  const sortedPremiumThemes = premiumThemes.sort((a, b) => {
    // Elysian always first
    if (a.id === "elysian") return -1;
    if (b.id === "elysian") return 1;
    // Then sort by rating (highest first)
    return b.rating - a.rating;
  });

  // Regular themes go in the main grid, Premium themes go in "Rich themes" section
  const visibleThemes = regularThemes;
  const moreThemes = sortedPremiumThemes;

  const activeTheme =
    SHOPIFY_THEMES.find(
      (t) => t.themeConfig.primaryColor === storeTheme?.primaryColor,
    ) || SHOPIFY_THEMES.find((t) => t.name === activeThemeName);

  const handleApply = (theme) => {
    const layoutPreset =
      THEME_LAYOUT_PRESETS[theme.id] || THEME_LAYOUT_PRESETS.dawn;

    const savedThemeData = allThemesById[theme.id] || {};
    const themeImageUrl =
      savedThemeData.themePreviewImage ||
      theme.image ||
      THEME_IMAGES[theme.id] ||
      THEME_IMAGES.dawn;

    let themeToApply;

    if (Object.keys(savedThemeData).length > 0) {
      themeToApply = {
        ...savedThemeData,
        themeId: theme.id,
        id: theme.id,
        themePreviewImage: themeImageUrl,
        layoutPreset,
        heroVariant: savedThemeData.heroVariant || layoutPreset.heroVariant,
        productVariant:
          savedThemeData.productVariant || layoutPreset.productVariant,
        themeSelectionSource: "preset",
        isActive: true,
      };
    } else {
      themeToApply = {
        ...theme.themeConfig,
        themeName: theme.name,
        themeId: theme.id,
        id: theme.id,
        themePreviewImage: themeImageUrl,
        layoutPreset,
        heroVariant: layoutPreset.heroVariant,
        productVariant: layoutPreset.productVariant,
        hideBanner: true,
        themeSelectionSource: "preset",
        isActive: true,
      };
    }

    onApplyTheme(themeToApply);
    toast.success(t("SETTINGS.THEME_APPLIED", { name: theme.name }));
  };

  return (
    <div className='space-y-6'>
      {/* ── Page header ───────────────────────────────────── */}
      <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-4 pb-2'>
        <div>
          <h2 className='text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight'>
            {t("SETTINGS.THEME_STORE.TITLE")}
          </h2>
          <p className='text-gray-500 dark:text-gray-400 text-sm mt-1'>
            {t("SETTINGS.THEME_STORE.SUBTITLE", {
              count: SHOPIFY_THEMES.length,
            })}
          </p>
        </div>
        {/* Search */}
        <div className='flex items-center gap-2 bg-gray-50 dark:bg-gray-700/60 border border-gray-200 dark:border-gray-600 rounded-xl px-4 py-2.5 w-full md:min-w-[240px] md:w-auto'>
          <MdSearch size={18} className='text-gray-400 shrink-0' />
          <input
            type='text'
            placeholder={t("SETTINGS.THEME_STORE.SEARCH_PLACEHOLDER")}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className='bg-transparent text-sm text-gray-700 dark:text-gray-300 placeholder-gray-400 dark:placeholder-gray-500 outline-none flex-1'
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className='text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors'
            >
              <MdClose size={16} />
            </button>
          )}
        </div>
      </div>

      {/* ── Active theme spotlight ─────────────────────────── */}
      {activeTheme && (
        <div className='relative rounded-2xl overflow-hidden border-2 border-green-200 dark:border-green-800 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20'>
          <div className='flex flex-col md:flex-row'>
            {/* Image thumbnail */}
            <div className='md:w-64 h-44 md:h-auto relative overflow-hidden shrink-0'>
              <img
                src={activeTheme.image}
                alt={activeTheme.name}
                className='w-full h-full object-cover'
              />
              <div
                className='absolute inset-0 opacity-40'
                style={{
                  backgroundColor: activeTheme.themeConfig.primaryColor,
                }}
              />
            </div>
            {/* Info */}
            <div className='flex-1 p-6 flex flex-col justify-center'>
              <div className='flex items-center gap-2 mb-3'>
                <span className='flex items-center gap-1.5 bg-green-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-sm'>
                  <MdCheckCircle size={12} />{" "}
                  {t("SETTINGS.THEME_STORE.CURRENT_THEME")}
                </span>
                <span className='text-xs bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 px-2.5 py-1 rounded-full font-medium'>
                  {getThemeCategory(t, activeTheme.category)}
                </span>
              </div>
              <h3 className='text-3xl font-extrabold text-gray-900 dark:text-white mb-1'>
                {activeTheme.name}
              </h3>
              <p className='text-gray-500 dark:text-gray-400 text-sm mb-4'>
                {getThemeTagline(t, activeTheme)}
              </p>
              <div className='flex items-center gap-3 flex-wrap'>
                <div className='flex gap-1.5'>
                  {activeTheme.colors.map((c, i) => (
                    <div
                      key={i}
                      className='w-7 h-7 rounded-full border-2 border-white shadow'
                      style={{ backgroundColor: c }}
                      title={c}
                    />
                  ))}
                </div>
                <span className='text-xs text-gray-400'>·</span>
                <span className='text-xs text-gray-500 dark:text-gray-400'>
                  <span className='font-semibold text-gray-700 dark:text-gray-300'>
                    {t("SETTINGS.THEME_STORE.FONT")}:
                  </span>{" "}
                  {activeTheme.themeConfig.fontFamily}
                </span>
                <button
                  onClick={() => onPreview(activeTheme)}
                  className='w-full sm:w-auto sm:ml-auto px-4 py-2 border-2 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl text-sm font-semibold hover:bg-white dark:hover:bg-gray-700 transition-colors'
                >
                  {t("SETTINGS.THEME_STORE.PREVIEW")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Category filters ────────────────────────────────── */}
      <div className='overflow-x-auto pb-1 -mx-1 px-1'>
        <div className='flex gap-2 min-w-max'>
          {CATEGORIES.map((cat) => {
            const count =
              cat === "All"
                ? SHOPIFY_THEMES.length
                : SHOPIFY_THEMES.filter((t) => t.category === cat).length;
            if (cat !== "All" && count === 0) return null;
            return (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all ${
                  activeCategory === cat
                    ? "bg-indigo-600 text-white shadow-md"
                    : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 dark:hover:text-indigo-400"
                }`}
              >
                {getThemeCategory(t, cat)}
                <span className='ml-1.5 text-xs opacity-70'>({count})</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Results count + clear ────────────────────────────── */}
      {(activeCategory !== "All" || searchQuery) && (
        <div className='flex items-center justify-between text-sm'>
          <span className='text-gray-500 dark:text-gray-400'>
            {t("SETTINGS.THEME_STORE.RESULTS", { count: filtered.length })}
          </span>
          <button
            onClick={() => {
              setActiveCategory("All");
              setSearchQuery("");
            }}
            className='text-indigo-600 dark:text-indigo-400 hover:underline font-medium'
          >
            {t("SETTINGS.THEME_STORE.CLEAR_FILTERS")}
          </button>
        </div>
      )}

      {/* ── Theme grid ────────────────────────────────────────── */}
      {filtered.length === 0 ? (
        <div className='text-center py-20'>
          <div className='text-6xl mb-4'>🎨</div>
          <h3 className='text-xl font-bold text-gray-700 dark:text-gray-300 mb-2'>
            {t("SETTINGS.THEME_STORE.NO_THEMES_FOUND")}
          </h3>
          <p className='text-gray-500 dark:text-gray-400 text-sm'>
            {t("SETTINGS.THEME_STORE.TRY_DIFFERENT_SEARCH")}
          </p>
        </div>
      ) : (
        <>
          {/* Main themes grid */}
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
            {visibleThemes.map((theme) => (
              <ThemeCard
                key={theme.id}
                theme={theme}
                isActive={
                  (activeThemeName && activeThemeName === theme.name) ||
                  (storeTheme?.primaryColor &&
                    storeTheme.primaryColor === theme.themeConfig.primaryColor)
                }
                onApply={handleApply}
                onPreview={onPreview}
              />
            ))}
          </div>

          {/* ── Rich Themes Section ────────────────────────────── */}
          {moreThemes.length > 0 && (
            <div className='mt-8'>
              <div className='flex items-center gap-3 mb-4'>
                <h3 className='text-xl font-extrabold text-gray-900 dark:text-white'>
                  🌟 Premium & Rich Themes
                </h3>
                <span className='text-xs bg-gradient-to-r from-amber-400 to-amber-500 text-white px-2.5 py-1 rounded-full font-medium'>
                  {"Featured"}
                </span>
              </div>
              <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
                {moreThemes.map((theme) => (
                  <ThemeCard
                    key={theme.id}
                    theme={theme}
                    isActive={
                      (activeThemeName && activeThemeName === theme.name) ||
                      (storeTheme?.primaryColor &&
                        storeTheme.primaryColor ===
                          theme.themeConfig.primaryColor)
                    }
                    onApply={handleApply}
                    onPreview={onPreview}
                  />
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ThemeGallery;
export { SHOPIFY_THEMES, THEME_LAYOUT_PRESETS };
